// Module
var code = "<div ng-show=\"vm.rendering\" class=\"detail-loading-indicator\" layout=\"row\" layout-align=\"center\"> <md-progress-circular md-theme=\"black\" md-mode=\"indeterminate\" md-diameter=\"30\"> </md-progress-circular> </div> <abx-room-details class=\"md-padding m-64-bot\" ng-model=\"vm.room\" abx-building=\"vm.building\"> </abx-room-details> ";
// Exports
module.exports = code;